import {useRequestVerificationMutation} from '#apollo/schema';
import {Link, Text} from '#component/base';
import {AuthCTAMessages} from '#component/partial';
import {SUPPORT_EMAIL} from '#constant/app';
import {useToastQueue} from '#hook';
import {sprinkles} from '#style/sprinkles';
import {getSignOutUrl} from '#util';

export const VerifyPendingAuthed: React.FC<{email?: string | null}> = ({email}) => {
  const [requestVerification, {loading}] = useRequestVerificationMutation();
  const {addToast} = useToastQueue();

  const handleRequestVerification = async () => {
    const {data} = await requestVerification();

    addToast({
      children: data?.requestVerification.success
        ? 'Verification email sent!'
        : 'Unable to send email!',
    });
  };

  return (
    <>
      <AuthCTAMessages
        title="One Last Step"
        messages={[
          <div className={sprinkles({direction: 'col', flex: 'flex'})} key={1}>
            <Text as="p" color="doveGray">
              We need to verify your account. We sent an email to {''}
              <Text color="doveGray" fontWeight={email ? 'semiBold' : 'regular'}>
                {email || 'your address'}
              </Text>{' '}
              to verify your account. Click the link in the email to complete your account setup.
            </Text>

            <Text as="p" color="doveGray" className={sprinkles({mT: 72})}>
              Didn’t receive your email?
              <br />
              Check your spam or{' '}
              <Link as="button" disabled={loading} onClick={handleRequestVerification}>
                resend email
              </Link>
              .
            </Text>

            <Text as="p" color="doveGray" className={sprinkles({mT: 36})}>
              If you&apos;re still not receiving an email, contact our support team at{' '}
              <Text as="a" href={`mailto:${SUPPORT_EMAIL}`} color="doveGray">
                {SUPPORT_EMAIL}
              </Text>
            </Text>
          </div>,
        ]}
      />

      <Text color="doveGray" textAlign="center">
        <Link href={getSignOutUrl()}>Log out</Link>
      </Text>
    </>
  );
};
